export default __webpack_public_path__ + "static/test-image-808d9f2eed605d12fd05d535f9660be5.jpg";